export class NativeViewSettings {
  constructor(overrides) {
    const defaults = {
      backgroundColor: '#e5e8ef',
      alphabetizeVendors: false,
      selectedVendorIndex: 0
    };
    return Object.assign(this, defaults, overrides);
  }
}
export const NativeViewTypes = {
  styles: {
    backgroundColor: {
      title: 'Background Color',
      type: 'ColorPicker'
    }
  },
  'vendor content': {
    alphabetizeVendors: {
      title: 'Sort Vendors Alphabetically?',
      type: 'Switch'
    },
    selectedVendorIndex: {
      title: 'Preview Vendor',
      type: 'VendorSelector'
    }
  }
};